import { render, staticRenderFns } from "./NetlinksBoughtPopup.vue?vue&type=template&id=ce8171e0&scoped=true&lang=html"
import script from "./NetlinksBoughtPopup.vue?vue&type=script&lang=js"
export * from "./NetlinksBoughtPopup.vue?vue&type=script&lang=js"
import style0 from "./NetlinksBoughtPopup.vue?vue&type=style&index=0&id=ce8171e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8171e0",
  null
  
)

export default component.exports